<template>
    <div class="page-bar">
        <div>
            <div class="page-bar-sub">Team / Skills Matrix</div>
            <div class="page-bar-main">{{ formData.Name }}</div>
        </div>
    </div>
    <div v-if="isLoaded">
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.teamHubRole == 'Admin'" class="page-filters pf-bar">
                <template v-if="editMode">
                    <div @click="() => { showEdit = true }" class="add-btn">Edit Name/Columns</div>
                    <div @click="() => { editMode = false; setDoubleScroll(); }" class="add-btn">View Mode</div>
                </template>
                <template v-else>
                    <div @click="() => { editMode = true; setDoubleScroll(); }" class="add-btn">Edit Mode</div>
                </template>
            </div>
            <div class="playbook">
                <div id="playbook-sheet-wrap" class="playbook-sheet-wrap skills-matrix-sheet-wrap">
                    <table id="playbook-sheet" class="playbook-sheet skills-matrix-sheet">
                        <tbody>
                            <tr>
                                <td></td>
                                <td v-for="(col, i) in formData.ColumnsJSON" :key="i">{{ col.name }}</td>
                            </tr>
                            <tr v-for="(row, i) in rows" :key="i">
                                <td>
                                    <div v-if="editMode" style="display:flex">
                                        <input type="text" v-model="row.Name" />
                                        <span @click.prevent="deleteRow(row)"><svg-icon style="width:18px;height:18px;color:red" icon="x"/></span>
                                    </div>
                                    <span v-else>{{ row.Name }}</span>
                                </td>
                                <td v-for="(col, j) in formData.ColumnsJSON" :key="'c'+j">
                                    <div v-if="editMode">
                                        <select v-model="row.ColumnsJSON[col.id]" @change="submitRow(row)">
                                            <option :value="0">{{ ratings[0].label }}</option>
                                            <option :value="1">{{ ratings[1].label }}</option>
                                            <option :value="2">{{ ratings[2].label }}</option>
                                            <option :value="3">{{ ratings[3].label }}</option>
                                            <option :value="4">{{ ratings[4].label }}</option>
                                        </select>
                                    </div>
                                    <div v-else>
                                        <svg-icon :style="'fill:'+ratings[row.ColumnsJSON[col.id]].color" icon="circle" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="42">
                                    <div style="display:flex;flex-wrap:wrap">
                                        <div v-for="i in 5" :key="i" style="display:flex;align-items:center;margin:5px 10px;">
                                            <svg-icon :style="'fill:'+ratings[i-1].color" icon="circle" />
                                            <span style="padding-left:10px">{{ ratings[i-1].label }}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <form v-if="editMode" @submit.prevent="addTeammate()" style="display:flex;margin-top:20px">
                    <input v-model="teammateInput" type="text" placeholder="Teammate Name" />
                    <button class="add-btn">Add Teammate</button>
                </form>
            </div>
        </div>

        <confirm-delete v-if="showConfirmDelete" @confirm="deleteConfirm" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to delete this row?"/>
        <add-edit-skills-matrix v-if="showEdit" @close="() => { showEdit = false; getData() }" :matrixToEdit="formData" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import AddEditSkillsMatrix from '@/components/AddEditSkillsMatrix.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';

export default defineComponent({
    name: 'SkillsMatrix',
    components: {
        ConfirmDelete,
        AddEditSkillsMatrix,
        SvgIcon,
    },
    data() {
        return {
            isLoaded: false,
            formData: {
                Name: '',
                ColumnsJSON: [] as any
            },
            rows: [] as any,
            editMode: false,
            showEdit: false,
            teammateInput: '',
            ratings: {
                0: {
                    color: '#E66442',
                    label: 'No Competence'
                },
                1: {
                    color: '#E6D441',
                    label: 'Low Competence'
                },
                2: {
                    color: '#41E641',
                    label: 'Some Competence'
                },
                3: {
                    color: '#42E1E7',
                    label: 'High Competence'
                },
                4: {
                    color: '#409AE6',
                    label: 'Expert'
                },
            } as any,
            idToDelete: null as any,
            showConfirmDelete: false
        }
    },
    async created() {
        if(!this.$route.params.id) {
            return;
        }

        if(this.$store.state.user.teamHubRole == 'Admin' && this.$route.query.edit) {
            this.editMode = true;
        }

        await this.getData();

        this.$store.state.routeLoaded = true;
        this.isLoaded = true;

        this.setDoubleScroll();
    },
    methods: {
        setDoubleScroll() {
            setTimeout(() => {
                const table = document.getElementById('playbook-sheet-wrap');
                if(table) {
                    this.doubleScroll(table);
                }
            }, 200)
        },
        async getData() {
            await axios.get(`${this.$store.state.apiUrl}/api/skillsmatrices/${this.$route.params.id}`)
                .then(resp => {
                    if(resp.data.ColumnsJSON) {
                        resp.data.ColumnsJSON = JSON.parse(resp.data.ColumnsJSON);
                    }
                    this.formData = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })

            await axios.get(`${this.$store.state.apiUrl}/api/skillsmatrices/rows/${this.$route.params.id}`)
                .then(resp => {
                    for(const row of resp.data) {
                        row.ColumnsJSON = JSON.parse(row.ColumnsJSON);
                        for(const col of this.formData.ColumnsJSON) {
                            if(!row.ColumnsJSON[col.id]) {
                                row.ColumnsJSON[col.id] = 0;
                            }
                        }
                    }
                    this.rows = resp.data;
                    console.log(this.rows);
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async addTeammate() {
            if(!this.teammateInput) {
                alert(`Enter teammate's name`);
                return;
            }

            const data = {
                Name: this.teammateInput.trim(),
                ColumnsJSON: {},
                MatrixID: this.$route.params.id
            }

            await axios.post(`${this.$store.state.apiUrl}/api/skillsmatrices/row`, data)
                .then(resp => {
                    this.teammateInput = '';
                    this.getData();
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        async submitRow(row: any) {
            await axios.post(`${this.$store.state.apiUrl}/api/skillsmatrices/row`, row)
                .catch(e => {
                    console.log(e);
                })
        },
        deleteRow(row: any) {
            this.idToDelete = row.ID;
            this.showConfirmDelete = true;
            console.log(row);
        },
        async deleteConfirm() {
            this.showConfirmDelete = false;
            await axios.delete(`${this.$store.state.apiUrl}/api/skillsmatrices/row/${this.idToDelete}`)
                .then(() => {
                    this.rows = this.rows.filter((row: any) => {
                        return row.ID != this.idToDelete;
                    })
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error');
                })
        }
    }
});
</script>